<div class="stepper-container">
  <mat-horizontal-stepper #stepper [selectedIndex]="this.getIndexForActiveStep()" (click)="triggerClick()">
    <!-- Always show numbers -->
    <ng-template matStepperIcon="number" let-index="index">
      {{ index + 1 }}
    </ng-template>

    <!-- Replace edit/done/error with the same number -->
    <ng-template matStepperIcon="edit" let-index="index">
      {{ index + 1 }}
    </ng-template>

    <ng-template matStepperIcon="done" let-index="index">
      {{ index + 1 }}
    </ng-template>

    <ng-template matStepperIcon="error" let-index="index">
      {{ index + 1 }}
    </ng-template>

    @for (step of _steps; track step) {
      <mat-step [aria-labelledby]="!step.enabled ? 'disabled' : null">
        <ng-template matStepLabel>
          @if (this._headerClick.observers.length > 0) {
            <div class="step-header-overlay" (click)="headerClick($event, step)"></div>
          }
          <span>{{ step.label }}</span>
        </ng-template>
      </mat-step>
    }
  </mat-horizontal-stepper>
</div>
